<template>
  <section>
    <div class="toolbar">
      <div>
        <h1>审核人员</h1>
        <p>按手机号给已有用户开通小程序端内容审核权限，移除后立即失效。</p>
      </div>
      <div class="add">
        <el-input v-model="phone" clearable maxlength="11" placeholder="输入用户手机号" style="width:200px" @keyup.enter.native="add" />
        <el-button type="primary" icon="el-icon-plus" :loading="adding" @click="add">添加</el-button>
        <el-button icon="el-icon-refresh" @click="load">刷新</el-button>
      </div>
    </div>
    <el-table v-loading="loading" :data="rows" border stripe>
      <el-table-column prop="name" label="用户昵称" min-width="160" />
      <el-table-column prop="phone" label="手机号" width="140" />
      <el-table-column prop="userId" label="用户 ID" width="100" />
      <el-table-column prop="createdAt" label="开通时间" width="180" />
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="s">
          <el-button type="text" class="danger" @click="remove(s.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="!loading && !rows.length" class="empty">还没有审核人员，添加后该用户可在小程序「我的 → 内容审核」直接审核内容。</div>
  </section>
</template>
<script>
import request from '@/api/request';
export default {
  data() {
    return { rows: [], phone: '', loading: false, adding: false };
  },
  created() { this.load(); },
  methods: {
    async load() {
      this.loading = true;
      try {
        const r = await request.get('/admin/reviewers');
        this.rows = r.data || [];
      } catch (e) {
        this.$message.error('审核人员加载失败');
      } finally { this.loading = false; }
    },
    async add() {
      const phone = String(this.phone || '').replace(/\s|-/g, '').trim();
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.warning('请输入正确的 11 位手机号');
        return;
      }
      if (this.adding) return;
      this.adding = true;
      try {
        await request.post('/admin/reviewers', { phone });
        this.phone = '';
        this.$message.success('已添加审核权限');
        await this.load();
      } catch (e) {
        this.$message.error((e.response && e.response.data && e.response.data.message) || '添加失败');
      } finally { this.adding = false; }
    },
    remove(row) {
      this.$confirm(`确定移除“${row.name || row.phone}”的审核权限吗？`, '提示', { type: 'warning' })
        .then(async () => {
          await request.delete(`/admin/reviewers/${row.id}`);
          this.$message.success('已移除审核权限');
          await this.load();
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped>
.toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.toolbar h1 { margin: 0; color: #24384b; font-size: 22px; }
.toolbar p { margin: 6px 0 0; color: #8493a1; font-size: 13px; }
.add { display: flex; gap: 10px; }
.empty { margin-top: 18px; color: #8493a1; font-size: 13px; text-align: center; }
.danger { color: #e05d5d; }
</style>
